<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="新增分校">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <courseUsageAnalysisReportFrom
        ref="ruleForm"
        :formLabelAlign="formLabelAlign"
      ></courseUsageAnalysisReportFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addBranchSchools } from "@/api/setting";
import courseUsageAnalysisReportFrom from "./components/courseUsageAnalysisReportFrom.vue";
export default {
  components: { courseUsageAnalysisReportFrom },
  data() {
    return {
      lan: [
        {
          label: "En",
          value: "En",
        },
        {
          label: "Zh",
          value: "Zh",
        },
      ],
      formLabelAlign: {
        abbreviation: null,
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addBranchSchools();
        }
      });
    },

    addBranchSchools() {
      addBranchSchools(this.formLabelAlign).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.$router.push({
          path: "/setting/courseUsageAnalysisReport",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>